/*
 * @Author: yeyimei
 * @Date: 2023-08-04 14:01:46
 * @LastEditTime: 2023-11-03 09:50:15
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\localProduct.routes.js
 */
export default [
  // {
  //   path: "/local",
  //   name: "local",
  //   component: () =>
  //     import("@/views/local-product/components/parentCpn/index.vue"),
  //   redirect: "/local/home",
  //   children: [
  //     {
  //       path: "home",
  //       name: "localHome",
  //       component: () => import("@/views/local-product/home/index.vue"),
  //       meta: {
  //         title: "邦客惠土特",
  //         showName: true,
  //       },
  //     },

  //     {
  //       path: "member",
  //       name: "localMember",
  //       component: () => import("@/views/mine/member/member.vue"),
  //       meta: {
  //         title: "会员中心",
  //       },
  //     },
  //     {
  //       path: "map-goods",
  //       name: "mapGoods",
  //       component: () => import("@/views/local-product/map-goods/index.vue"),
  //       meta: {
  //         title: "特产地图",
  //       },
  //     },
  //     {
  //       path: "mine",
  //       name: "localMine",
  //       component: () => import("@/views/mine/index.vue"),
  //       meta: {
  //         title: "我的",
  //       },
  //     },
  //     {
  //       path: "activities",
  //       name: "localActivities",
  //       component: () => import("@/views/activities/index.vue"),
  //       meta: {
  //         title: "最新活动",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/local/home",
    name: "localHome",
    component: () => import("@/views/local-product/home/index.vue"),
    meta: {
      title: "邦客惠土特",
      showName: true,
      isLocalTabBar:true
    },
  },

  {
    path: "/local/member",
    name: "localMember",
    component: () => import("@/views/mine/member/member.vue"),
    meta: {
      title: "会员中心",
      isLocalTabBar:true
    },
  },
  {
    path: "/local/map-goods",
    name: "mapGoods",
    component: () => import("@/views/local-product/map-goods/index.vue"),
    meta: {
      title: "特产地图",
      isLocalTabBar:true
    },
  },
  {
    path: "/local/mine",
    name: "localMine",
    component: () => import("@/views/mine/index.vue"),
    meta: {
      title: "我的",
      isLocalTabBar:true
    },
  },
  {
    path: "/local/activities",
    name: "localActivities",
    component: () => import("@/views/activities/index.vue"),
    meta: {
      title: "最新活动",
      isLocalTabBar:true
    },
  },
  {
    path: "/local/classify",
    name: "localClassify",
    component: () =>
      import(
        /* webpackChunkName: "classify" */ "@/views/preferential-mall/classify.vue"
      ),
    // component: classifyPage,
    meta: {
      title: "分类",
      keepAlive: true,
    },
  },
]
